import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import InputNumber from 'component/gama/InputNumber'
import Mask from 'vanilla-masker'

class EnableInput extends Component {
  componentWillMount() {
    this.props.fieldNumber.input.value = this.props.fieldNumber.input.value
      ? `${this.props.fieldNumber.initialValue}%`
      : this.props.fieldNumber.input.value
  }

  customInputLabel = (label) => {
    const { translate } = this.props
    return <span>{translate(label)}</span>
  }

  customInputLabelWithComponent = (
    customField,
    customFieldId,
    label,
    customLabel,
    fieldEnabled
  ) => {
    const { translate } = this.props
    return (
      <div className={'display-with-component'}>
        <span className={'padding-right'}>{translate(label)}</span>

        <Field
          {...customField}
          className='no-margin'
          disabledHelper
          validate
          error={translate(customField.error)}
        >
          <InputNumber
            {...customField.input}
            id={customFieldId}
            className={'size-input'}
            maxLength={3}
            disabled={!fieldEnabled.input.value}
            separator=''
            delimiter=''
          />
        </Field>

        <span className={'padding-left'}>{translate(customLabel)}</span>
      </div>
    )
  }

  handleOnChange = (e, disabled, fieldNumber, fieldEnabled, customField) => {
    this.props.cleanFieldNumber(disabled, fieldNumber)
    /* istanbul ignore else */
    if (customField) {
      this.props.cleanFieldNumber(disabled, customField)
    }
    fieldEnabled.input.onChange(e)
  }

  percentageMask = (e) => {
    const value = e.target.value.replace(/[^\d]+/g, '')

    let mask
    const separator = ','
    switch (value.length) {
      case 1:
        mask = '9%'
        break
      case 2:
        mask = '99%'
        break
      case 3:
        mask = value === '100' ? `999%` : `99${separator}9%`
        break
      case 4:
        mask = `99${separator}99%`
        break
      default:
        mask = '99,99%'
        break
    }

    e.target.value = Mask.toPattern(value, mask)

    this.props.fieldNumber.input.onChange(e)
    // moves back cursor
    e.target.selectionEnd = e.target.selectionStart = e.target.value.length - 1
  }

  render() {
    const {
      translate,
      fieldEnabled,
      idEnabled,
      fieldNumber,
      idNumber,
      label,
      fieldEnabledClass,
      fieldNumberClass,
      containerClass,
      customInputLabelWithComponent,
      customField,
      customFieldId,
      customLabel,
      disabled,
      inputClass,
      maxLength,
    } = this.props

    return (
      <div className='enable-input margin-bottom'>
        <Row className={`${containerClass || ''}`}>
          <Col
            xs={10}
            sm={10}
            md={10}
            lg={10}
            className={`enabled-col no-margin ${fieldEnabledClass || ''}`}
          >
            {fieldEnabled && (
              <Field className={'full-whidt no-margin'} {...fieldEnabled}>
                <div className={'dashed-border'}>
                  <Input
                    {...fieldEnabled.input}
                    className={inputClass}
                    id={idEnabled}
                    type='checkbox'
                    onChange={(e) =>
                      this.handleOnChange(
                        e,
                        disabled,
                        fieldNumber,
                        fieldEnabled,
                        customField
                      )
                    }
                    maxLength={maxLength}
                    label={
                      customInputLabelWithComponent
                        ? this.customInputLabelWithComponent(
                            customField,
                            customFieldId,
                            label,
                            customLabel,
                            fieldEnabled
                          )
                        : this.customInputLabel(label)
                    }
                  />
                </div>
              </Field>
            )}
          </Col>
          <Col
            xs={2}
            sm={2}
            ms={2}
            lg={2}
            className={`enabled-col ${fieldNumberClass || ''}`}
          >
            {fieldNumber && (
              <Field
                {...fieldNumber}
                className={'full-whidt no-margin'}
                disabledHelper
                validate
                error={translate(fieldNumber.error)}
              >
                <Input
                  {...fieldNumber.input}
                  id={idNumber}
                  className={'size-input'}
                  disabled={disabled ? !fieldEnabled.input.value : false}
                  onChange={this.percentageMask}
                  placeholder={'%'}
                />
              </Field>
            )}
          </Col>
        </Row>
        <div className={'flex column'}>
          {!!customField && !!customField.error && (
            <span className={'helper'}>{customField.error}</span>
          )}
          {!!fieldNumber && !!fieldNumber.error && (
            <span className={'helper'}>{fieldNumber.error}</span>
          )}
        </div>
      </div>
    )
  }
}

EnableInput.propTypes = {
  fieldEnabled: PropTypes.object,
  idEnabled: PropTypes.string,
  fieldNumber: PropTypes.object,
  idNumber: PropTypes.string,
  label: PropTypes.string,
  translate: PropTypes.func.isRequired,
  fieldEnabledClass: PropTypes.string,
  fieldNumberClass: PropTypes.string,
  containerClass: PropTypes.string,
  customField: PropTypes.object,
  customFieldId: PropTypes.string,
  customLabel: PropTypes.string,
  customInputLabelWithComponent: PropTypes.bool,
  disabled: PropTypes.bool,
  inputClass: PropTypes.string,
  maxLength: PropTypes.number,
  cleanFieldNumber: PropTypes.func.isRequired,
}

export default EnableInput
